module.exports = __webpack_public_path__ + "static/media/seaseeker_logo_full.0a0a5b62.png";